// 🐨 type this properly
const queryBuilder = queryParams => {
  return Object.entries(queryParams).reduce((accumulatedString, queryNameAndVal, index) => {
    const queryName = queryNameAndVal[0];
    const queryVal = queryNameAndVal[1];

    if (!queryVal) return accumulatedString;

    const queryStructure = `${queryName}=${queryVal}`;
    return index === 0
      ? `${accumulatedString}?${queryStructure}`
      : `${accumulatedString}&${queryStructure}`;
  }, '');
};

export default queryBuilder;
